<template>
  <div
    class="fab-container"
    @click="goHome"
    @mousedown="startDrag"
    @touchstart="startDrag"
    @mousemove="onMove"
    @touchmove="onMove"
    @mouseup="endDrag"
    @touchend="endDrag"
    ref="fab"
  >
    <van-icon name="home-o" size="24" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const fab = ref(null)
const isDragging = ref(false)
const startX = ref(0)
const startY = ref(0)
const offset = reactive({ x: 0, y: 0 })
const threshold = 5

function goHome() {
  if (!isDragging.value) {
    router.push('/')
  }
  isDragging.value = false
}

function startDrag(e) {
  const clientX = e.touches ? e.touches[0].clientX : e.clientX
  const clientY = e.touches ? e.touches[0].clientY : e.clientY
  const el = fab.value
  const rect = el.getBoundingClientRect()

  startX.value = clientX
  startY.value = clientY
  offset.x = clientX - rect.left
  offset.y = clientY - rect.top

  el.style.right = 'auto'
  el.style.top = `${rect.top}px`
  el.style.left = `${rect.left}px`
  el.style.transform = 'none'

  document.addEventListener('mousemove', onMove)
  document.addEventListener('mouseup', endDrag)
  document.addEventListener('touchmove', onMove)
  document.addEventListener('touchend', endDrag)
}

function onMove(e) {
  const clientX = e.touches ? e.touches[0].clientX : e.clientX
  const clientY = e.touches ? e.touches[0].clientY : e.clientY
  const dx = Math.abs(clientX - startX.value)
  const dy = Math.abs(clientY - startY.value)

  if (dx > threshold || dy > threshold) {
    isDragging.value = true
  }
  if (!isDragging.value) return

  const el = fab.value
  const finalX = Math.max(0, Math.min(clientX - offset.x, window.innerWidth - el.offsetWidth))
  const finalY = Math.max(0, Math.min(clientY - offset.y, window.innerHeight - el.offsetHeight))
  el.style.left = `${finalX}px`
  el.style.top = `${finalY}px`
}

function endDrag() {
  document.removeEventListener('mousemove', onMove)
  document.removeEventListener('mouseup', endDrag)
  document.removeEventListener('touchmove', onMove)
  document.removeEventListener('touchend', endDrag)
  isDragging.value = false
}
</script>

<style scoped>
.fab-container {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background-color: #1989fa;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  cursor: grab;
  transition: background-color 0.3s ease;
  user-select: none;
  -webkit-user-drag: none;
}

.fab-container:hover {
  background-color: #1571d6;
  cursor: grabbing;
}
</style>
